import { createContext } from 'react';

import type { Context } from '../types/hotel-images';

export const HotelImagesContext = createContext<Partial<Context>>({});
